import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/einstellungen/")({
  beforeLoad: () => {
    throw redirect({ to: "/einstellungen/konto", replace: true });
  },
});
